import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import {useTranslation} from "react-i18next";
import { act } from "react";


const ButtonContainer = styled.div`
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    justify-content: center;

    @media (max-width: 600px) {
        gap: 8px; /* Mniejszy odstęp między przyciskami na mniejszych ekranach */
    }
`;

const Button = styled.button`
    padding: 10px 20px;
    border: 1px solid #ccc;
    background-color: white;
    font-weight: bold;
    cursor: pointer;
    flex: 1 1 auto;
    min-width: 120px;
    text-align: center;
    font-size: 16px;

    &:hover:not(.active) {
        background-color: #f0f0f0; /* Lekko szare tło po najechaniu na przycisk */
    }

    &.active {
        background-color: #ffffcc; /* Jasnożółte tło dla aktywnego przycisku */
    }

    @media (max-width: 600px) {
        padding: 10px 15px; /* Mniejsze marginesy wewnętrzne na mobilnych */
        font-size: 14px; /* Zmniejszenie czcionki */
    }
`;

const MenuButtons = ({projectId, active}) => {
    const navigate = useNavigate();
    const { t } = useTranslation();


    return (<>
        <div className='mb-3 px-0'>
        {/*BUTTONS*/}
            <ButtonContainer>
                <Button className={active.table} onClick={() => {navigate("/projects/current/"+projectId)}}>
                    {t("common.button.table_view")}
                </Button>
                <Button className={active.summary} onClick={() =>{navigate("/projects/current/summary-view/"+projectId)}}>
                    {t("common.button.summary_view")}
                </Button>
                <Button className={active.finanse}>
                    {t("common.button.finances_view")}
                </Button>
                <Button className={active.website}>
                    {t("common.button.website_view")}
                </Button>
            </ButtonContainer>
        </div>
    </>)
}

export default MenuButtons
